import React from 'react'
import ValueSection from './Sections/ValueSection'
import PageShell from '../PageShell'

const AboutUs = () => {
    return (
        <PageShell
            title="Our Success Starts With Yours"
            blurb="We live and breath serving our customers. We drive ourselves to innovate. Not only because we love it - but because it helps our customers succeed."
            img={require('assets/img/about-bg.jpg')}
            components={[<ValueSection key={0} />]}
        />
    )
}

export default AboutUs



// WEBPACK FOOTER //
// ./src/views/AboutUs/AboutUs.jsx